import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from './components/Navbar/NavBar';
import { Home } from './components/Home/Home';
import { Skills } from './components/Skills.js/Skills';
import { Projects } from './components/Projects/Projects';
import { Contact } from './components/Contact/Contact';
import { About } from './components/About/About';
import Footer from './components/Footer/Footer';


function App() {
  return (
    <div className="App">
      <NavBar/>
      <Home />
      <About />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
